export default __webpack_public_path__ + "static/media/pizza-image.7d195739.jpg";